// extracted by mini-css-extract-plugin
module.exports = {"heading":"HeadingSection_heading__nTX3V"};